export const mapDataToClient = (oldData, updatedData) => ({
  theme: updatedData?.theme || oldData.theme,
  background: updatedData?.background || oldData.background,
  onboardingPassed: updatedData?.onboardingPassed || oldData.onboardingPassed,
  brikksOrder: updatedData?.brikksOrder ? JSON.parse(updatedData.brikksOrder) : oldData.brikksOrder,
});
